import "./SingleProduct.scss";
import ProductBottom from "./components/ProductBottom/ProductBottom";
import ProductOverview from "./components/ProductOverview/ProductOverview";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { getComboMeal, getMeal } from "../../services/meals";

export default function SingleProduct({
  id,
  cart,
  setCart,
  showMessage,
  setShowMessage,
  showAllId,
  setShowAllId,
  setActive,
}) {
  const [cookie] = useCookies(["access_token"]);
  const [product, setProduct] = useState({});
  const [isActive, setIsActive] = useState(true);
  const isCombo = String(window.location.pathname)?.includes("combos");
  useEffect(() => {
    isCombo
      ? getComboMeal(id, cookie?.access_token).then((res) => setProduct(res))
      : getMeal(id, cookie?.access_token).then((res) => setProduct(res));
  }, []);

  useEffect(() => {
    product?.category && setIsActive(product?.category?.isActive);
  }, [product]);

  useEffect(() => {
    product?.category?.id
      ? localStorage.setItem("activeMenu", product?.category?.id)
      : product?.subcategory?.id && localStorage.setItem("activeMenu", 12);
  }, [product]);
  return (
    <>
      <ProductOverview
        isCombo={isCombo}
        product={product}
        cart={cart}
        setCart={setCart}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
        showAllId={showAllId}
        setShowAllId={setShowAllId}
        isActive={isActive}
        setActive={setActive}
      ></ProductOverview>
      <ProductBottom
        isCombo={isCombo}
        product={product}
        cart={cart}
        setCart={setCart}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
      ></ProductBottom>
    </>
  );
}
